import { A9Service, AbstractDataProviderV2 } from 'components/system';

import { RsInterest } from 'common/customers/services/types/RsInterest';
import { RsInterestInfo } from 'common/customers/services/types/RsInterestInfo';
import { InterestAdd } from 'common/customers/services/types/InterestAdd';
import { InterestUpdate } from 'common/customers/services/types/InterestUpdate';

export function interestFromGetToUpdate(data: RsInterestInfo): InterestUpdate {
    return {
        active: data.active,
        name: data.name,
        shortName: data.name,
        notes: data.notes,
        orderNo: data.orderNo
    };
}

@A9Service('interestDataProvider')
export class InterestDataProvider extends AbstractDataProviderV2<RsInterest, RsInterestInfo, InterestAdd, InterestUpdate> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/interests');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
